import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { language, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    changeLanguage(language === 'en' ? 'ru' : 'en');
  };

  return (
    <button 
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label={`Switch to ${language === 'en' ? 'Russian' : 'English'}`}
    >
      <span className="lang-text">{language === 'en' ? 'РУ' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
